var acc = document.getElementsByClassName("accordion");
var i;



// Returns width of browser viewport
   if($( window ).width() > 950){
   //If you want to add dynamically a class or remove one
   for (i = 0; i < acc.length; i++) {
    acc[i].onclick = function(){
        this.classList.toggle("active");
        this.nextElementSibling.classList.toggle("show");
    }
	
}   $(document).ready(function() {
 $(".accordion").trigger("click");
});


   }
   
 // Returns width of browser viewport
   if($( window ).width() < 768){
   //If you want to add dynamically a class or remove one
   for (i = 0; i < acc.length; i++) {
    acc[i].onclick = function(){
        this.classList.toggle("active");
        this.nextElementSibling.classList.toggle("show");
    }
}
   }
   
